import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { axiosInstance as axios } from '../../../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';

const EMPTY = { ease_rating: 0, value_most: '', missing: '', family_benefit: '', would_continue: '', fair_price: '', comments: '' };
const QUESTIONS = [
  ['value_most', 'What do you value most about Legacy Forge so far?', true],
  ['missing', 'What is missing or confusing?'],
  ['family_benefit', 'How could this help the families you serve?'],
  ['fair_price', 'What would feel like a fair monthly price for a professional listing?'],
  ['comments', 'Anything else?'],
];

function Choice({ options, value, onChange, testId }) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map(([v, l]) => (
        <button type="button" key={v} onClick={() => onChange(v)} data-testid={`${testId}-${v}`}
                className={`px-3 py-1.5 rounded-full text-sm border ${value === v ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-gray-700 border-gray-300'}`}>{l}</button>
      ))}
    </div>
  );
}

export function PilotSurveyDialog({ open, onClose, initial, onSaved }) {
  const [f, setF] = useState(EMPTY);
  useEffect(() => { if (open) setF({ ...EMPTY, ...(initial || {}) }); }, [open, initial]);
  const ready = f.ease_rating && f.would_continue && f.value_most.trim();

  const submit = async () => {
    try {
      const body = Object.fromEntries(Object.entries(f).filter(([k]) => k in EMPTY).map(([k, v]) => [k, v === '' ? null : v]));
      await axios.put('/api/pilot/pro/survey', body);
      toast.success('Thank you — your feedback was saved');
      onSaved();
      onClose();
    } catch {
      toast.error('Could not save feedback');
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="pilot-survey-dialog">
        <DialogHeader>
          <DialogTitle>Pilot feedback</DialogTitle>
          <DialogDescription>Honest answers help most. You can update this any time.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <p className="text-sm font-medium mb-2">How easy is the platform to use? *</p>
            <Choice options={[1, 2, 3, 4, 5].map(n => [n, String(n)])} value={f.ease_rating} onChange={v => setF({ ...f, ease_rating: v })} testId="survey-ease" />
          </div>
          {QUESTIONS.map(([k, q, req]) => (
            <div key={k}>
              <p className="text-sm font-medium mb-1">{q}{req ? ' *' : ''}</p>
              <textarea rows={2} value={f[k] || ''} onChange={e => setF({ ...f, [k]: e.target.value })} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" data-testid={`survey-${k}`} />
            </div>
          ))}
          <div>
            <p className="text-sm font-medium mb-2">Would you continue as a Legacy Forge professional after the pilot? *</p>
            <Choice options={[['yes', 'Yes'], ['maybe', 'Maybe'], ['no', 'No']]} value={f.would_continue} onChange={v => setF({ ...f, would_continue: v })} testId="survey-continue" />
          </div>
          <button onClick={submit} disabled={!ready} className="w-full bg-emerald-600 text-white rounded-lg py-2.5 font-semibold disabled:opacity-50" data-testid="survey-submit-btn">Submit feedback</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
